const codeModule = {
  "101": "No data received",
  "102": "Signature verification failed, Please Re-login",
  "103": "Verification code sending failed",
  "104": "Lack cell-phone number",
  "105": "Lack password",
  "106": "This number has been registered, please go back to login.",
  "111": "Registration failed",
  "107": "Verification code error",
  "108": "Account and password don’t match",
  "109": "The account does not exist",
  "110": "Password change failed",
  "112": "Exit failed",
  "113": "Failed to modify user information",
  "114": "Missing parameter",
  "115": "Fail to save",
  "121": "The card information is incomplete",
  "122": "No ID",
  "201": "The store doesn't exist",
  "202": "Dining table doesn’t exist",
  "203": "Non continuous message",
  "204": "The user has not spent any money in any store",
  "205": "Food plaza doesn’t exist",
  "206": "The store hasn’t operated",
  "301": "No product type added",
  "302": "The product doesn’t exist",
  "303": "Sold out",
  "304": "Please input the number of persons suitable for this set meal",
  "305": "The dish doesn’t exist",
  "306": "The set meal doesn’t exist",
  "307": "In-store is not supported",
  "308": "Delivery and pickup is not supported",
  "309": "Insufficient inventory of some goods",
  "400": "Verification code is incorrect",
  "401": "Delivery address doesn’t exist",
  "403": "Beyond delivery address",
  "404": "No product in shopping trolley",
  "405": "Please input the number of diners",
  "407": "Please select dining-table",
  "408": "This dining-table has been locked",
  "409": "Hasn’t reached minimum delivery amount",
  "410": "Total amount must be more than 1 Yen",
  "411": "Failed to add order, please try again",
  "412": "The order does not exist",
  "413": "This order has been paid",
  "415": "This order has been commented",
  "416": "Please select rating",
  "417": "Comment failed, please try again",
  "418": "Receipt has been printed",
  "419": "Printing failed",
  "420": "Please fill in the company name",
  "421": "This order hasn’t been commented",
  "422": "The order paid can’t be canceled",
  "423": "Failed to cancel",
  "424": "You have no authority to operate this order",
  "425": "Failed to confirm receipt",
  "426": "No dish can be added to this order",
  "427": "Credit card information error, please check it",
  "428": "Payment failure, please check it and try again",
  "429": "Beyond pickup time",
  "430": "Beyond delivery time",
  "431": "Unsupported mode of payment",
  "433": "Not during the appointment",
  "501": "Coupon does not exist",
  "502": "Claimed",
  "503": "Exceed the single claim limit",
  "504": "Failed to collect, please try again",
  "505": "The coupon has been used or expired",
  "506": "The conditions for use are not met",
  "1000": "Please delete multi-specification goods from shopping trolley!",
  "1001": "Successful to confirm receipt"
};

export default codeModule;
